import { PageHero } from "@/components/primitives";
import CapabilitiesShowcase from "@/sections/CapabilitiesShowcase";
import BeaconMethod from "@/sections/BeaconMethod";
import FinalCTA from "@/sections/FinalCTA";

export default function Capabilities() {
  return (
    <div data-testid="capabilities-page">
      <PageHero
        label="Capabilities"
        lines={["Outcomes, not", "a list of services."]}
        intro="We work across four connected capability areas — each designed to move your organization further along the path from visibility to influence."
      />
      <CapabilitiesShowcase withHeader={false} />
      <BeaconMethod />
      <FinalCTA />
    </div>
  );
}
